// Display helpers. Money from the API is in paise; dates are shown in the organisation's locale.

const inr = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 2 });

export function rupees(paise: number | null | undefined): string {
  return inr.format((paise ?? 0) / 100);
}

export function dateOnly(v: string | null | undefined): string {
  if (!v) return '–';
  const d = new Date(v);
  return Number.isNaN(d.getTime())
    ? '–'
    : d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
}

export function dateTime(v: string | null | undefined): string {
  if (!v) return '–';
  const d = new Date(v);
  return Number.isNaN(d.getTime())
    ? '–'
    : d.toLocaleString('en-IN', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      });
}

export function daysLeft(until: string | null): number {
  if (!until) return 0;
  return Math.max(0, Math.ceil((new Date(until).getTime() - Date.now()) / 86_400_000));
}

export const LEAD_STATUS: Record<string, { label: string; tone: 'success' | 'neutral' | 'warning' }> = {
  EXCLUSIVE: { label: 'Protected for you', tone: 'success' },
  LAPSED: { label: 'Protection ended', tone: 'neutral' },
  NOT_ACCEPTED: { label: 'Not accepted', tone: 'warning' },
};

export const CLAIM_STATUS: Record<
  string,
  { label: string; tone: 'info' | 'success' | 'danger' | 'warning' | 'primary' }
> = {
  CLAIMED: { label: 'Waiting for approval', tone: 'info' },
  APPROVED: { label: 'Approved: send your invoice', tone: 'warning' },
  REJECTED: { label: 'Not approved', tone: 'danger' },
  INVOICED: { label: 'Invoice received', tone: 'primary' },
  PAID: { label: 'Paid', tone: 'success' },
};

export const ENTRY_STATUS: Record<string, string> = {
  ACCRUED: 'Ready to claim',
  CLAIMED: 'On a claim',
  REVERSED: 'Cancelled booking',
};

export const OUTCOME: Record<string, string> = {
  OPEN: 'In progress',
  WON: 'Booked',
  LOST: 'Closed',
  JUNK: 'Closed',
};
